import cx from "classnames";
import { Component, FocusEvent } from "react";
import { injectIntl, IntlShape } from "react-intl";
import { IconSearch } from "../../../Icon/Icon";
import "./TextInput.scss";

type Props = {
  id: string;
  type: string;
  onChange: (id: string, value: string) => void;
  className?: string;
  value?: string;
  placeholder?: { id: string };
  label?: string;
  intl: IntlShape;
  autoComplete: string;
  disabled: boolean;
  autoFocus?: boolean;
  removeDefaultStyle?: boolean;
  inlineLabel?: boolean;
  handleBlur?: Function;
  required?: boolean;
};

class TextInput extends Component<Props> {
  handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.isTrusted) return;
    let id = this.props.id;
    let value = event.target.value;
    this.props.onChange(id, value);
  };

  render() {
    const {
      type,
      placeholder,
      id,
      value,
      className,
      intl,
      label,
      autoComplete,
      disabled,
      autoFocus,
      removeDefaultStyle,
      inlineLabel,
      required,
    } = this.props;

    let classes = cx("text-input__input", className);

    if (removeDefaultStyle) {
      classes = className;
    }
    const handleBlur = (
      id: string,
      value: FocusEvent<HTMLInputElement, Element>
    ) => {
      this.props.handleBlur && this.props.handleBlur(id, value);
    };

    return (
      <div
        className={`text-input ${type === "search" && "text-input--search"} ${
          inlineLabel ? "text-input__inline-label" : ""
        }`}
      >
        {type === "search" && (
          <IconSearch className="text-input__search-icon--small" />
        )}
        {label && (
          <label className="text-input__label" htmlFor={id}>
            {intl.formatMessage(label)}
            {required && "*"}
          </label>
        )}
        <input
          type={type}
          pattern={type === "number" ? "[0-9]*" : undefined} // Fix for number pad not showing on IOS
          onChange={e => this.handleInput(e)}
          placeholder={
            placeholder != null && placeholder.id !== undefined
              ? intl.formatMessage({ id: placeholder.id })
              : ""
          }
          className={classes}
          id={id}
          value={value}
          autoComplete={autoComplete}
          disabled={disabled}
          autoFocus={autoFocus}
          onBlur={e => {
            handleBlur(id, e);
          }}
        />
      </div>
    );
  }
}

export default injectIntl(TextInput) as any;
